import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { SpecialAssistanceRequestSpecialAssistanceData } from '@common/interfaces/mybooking/modals/passenger-information-input/special-assistance-request-modal.interface';

/**
 * サポート情報入力モーダル
 */
@Component({
  selector: 'asw-special-assistance-request-modal-special-assistance',
  templateUrl: './special-assistance-request-modal-special-assistance.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialAssistanceRequestModalSpecialAssistanceComponent implements OnDestroy {
  @Input()
  get data() {
    return this._data;
  }
  set data(value: SpecialAssistanceRequestSpecialAssistanceData | undefined) {
    this._data = value;
    this.refresh();
  }
  private _data?: SpecialAssistanceRequestSpecialAssistanceData;

  @Output()
  dataChange: EventEmitter<SpecialAssistanceRequestSpecialAssistanceData> =
    new EventEmitter<SpecialAssistanceRequestSpecialAssistanceData>();

  public id = this.constructor.name;
  public degreeOfWalking: boolean = false;
  public blind: boolean = false;
  public deaf: boolean = false;
  public pregnant: boolean = false;

  constructor(private _change: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.apply();
  }

  refresh() {
    this.degreeOfWalking = this.data?.degreeOfWalking ?? false;
    this.blind = this.data?.blind ?? false;
    this.deaf = this.data?.deaf ?? false;
    this.pregnant = this.data?.pregnant ?? false;

    this._change.detectChanges();
  }

  apply() {
    if (!this.data) {
      return;
    }

    this.data.degreeOfWalking = this.degreeOfWalking;
    this.data.blind = this.blind;
    this.data.deaf = this.deaf;
    this.data.pregnant = this.pregnant;

    this.dataChange.emit(this.data);
  }

  get isDisableDegreeOfWaling(): boolean {
    return Boolean(this.data?.isDisableDegreeOfWaling);
  }
}
